import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTicketIssueTypes } from '../../api';
import IssuesList from './IssuesList';
import { Shimmer } from '../common';

export default function TicketCreateNew() {
  const [issuTypesArr, setIssuTypesArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const pageType = queryParams.get('pageType');

  useEffect(() => {
    const handleGetTicketIssueTypes = async () => {
      try {
        setLoading(true);
        const resp = await getTicketIssueTypes();
        setIssuTypesArr(resp?.errorCode === 0 ? resp?.result?.issueTypesArr || [] : []);
      } catch (err) {
        console.log('Error in getting issue types', err);
      }
      setLoading(false);
    };
    handleGetTicketIssueTypes();
  }, []);

  const handleRedirectDummyTicketCreate = async (selectedIssueVal = '') => {
    sessionStorage.removeItem('ticketResp');
    const encodedIssueType = encodeURIComponent(selectedIssueVal);
    navigate(`/csportal/create_ticket_page?issueType=${encodedIssueType}&pageType=${pageType}`);
  };

  return (
    <div className="p-20">
      {loading ? (
        <Shimmer id="faq" />
      ) : (
        <>
          <IssuesList issuTypesArr={issuTypesArr} handleRedirectDummyTicketCreate={handleRedirectDummyTicketCreate} />
        </>
      )}
    </div>
  );
}
